import AuthenticatedImage from "../../../Common/AuthenticatedImage";
import "./GlobalLibraryCatalog.css";

const GlobalLibraryCatalog = ({
    articles,
    selectedArticle,
    onSelect,
    checkedIds,
    onCheckedIdsChange,
    canCheck,
    isImported,
    onImportOne,
    isOwner,
}) => {
    const toggleItem = (id) => {
        const next = new Set(checkedIds);
        next.has(id) ? next.delete(id) : next.add(id);
        onCheckedIdsChange(next);
    };

    if (articles.length === 0) {
        return <div className="gl-catalog-empty">No articles found.</div>;
    }

    return (
        <div className="gl-catalog-grid">
            {articles.map((article) => {
                const checkable = canCheck(article);
                const imported = isImported(article);
                const thumb = article.images?.[0];

                return (
                    <div
                        key={article.id}
                        className={`gl-card ${
                            selectedArticle?.id === article.id ? "selected" : ""
                        }`}
                        onClick={() => onSelect(article)}
                    >
                        <input
                            type="checkbox"
                            className="gl-card-checkbox"
                            checked={checkedIds.has(article.id)}
                            disabled={!checkable}
                            title={
                                !checkable
                                    ? imported
                                        ? "Already imported"
                                        : "Not available"
                                    : undefined
                            }
                            onChange={() => toggleItem(article.id)}
                            onClick={(e) => e.stopPropagation()}
                        />

                        {imported && <span className="gl-card-badge">Imported</span>}

                        <div className="gl-card-thumb">
                            {thumb ? (
                                 <AuthenticatedImage
                                    articleId={article.id}
                                    blobName={thumb}
                                    alt={article.name}
                                />
                            ) : (
                                <div className="gl-card-thumb-placeholder">No image</div>
                            )}
                        </div>

                        <div className="gl-card-body">
                            <div className="gl-card-name" title={article.name}>
                                {article.name}
                            </div>
                            <div className="gl-card-manufacturer">
                                {article.manufacturer || "—"}
                            </div>
                            <div className="gl-card-number">{article.articleNumber || ""}</div>
                        </div>

                        {!isOwner && (
                            <button
                                className="gl-card-import-btn"
                                disabled={imported}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onImportOne(article);
                                }}
                            >
                                {imported ? "Imported" : "Import"}
                            </button>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default GlobalLibraryCatalog;